import instance from '../_http';

export default {
    /**
     * 添加
     * @param {*} website
     * @returns
     */
    add: (website) => {
        return instance.post('/api/property/office-equipment',website);
    },
    /**
     *  删除
     */
    remove: (id) => {
        return instance.delete(`/api/property/office-equipment/${id}`);
    },
    /**
     * 更新
     * @param {*} website
     * @returns
     */
    update: (website) => {
        return instance.put('/api/property/office-equipment',website);
    },
    /**
     * 查询
     * @param {*} query
     * @returns
     */
    query: (query,page) => {
        return instance.get('/api/property/office-equipment',{params:{...query,page:page.page,size:page.size,sort:page.sort}});
    },
    /**
     * 详情
     * @param {*} id
     * @returns
     */
    detail: (id) => {
        return instance.get(`/api/property/office-equipment/${id}`);
    },
    /**
     * 修改设备类型
     * @param {*} id
     * @param {*} value
     * @returns
     */
    changeType: (id,value)=>{
        return instance.put(`/api/property/office-equipment/${id}/type/${value}`);
    }
}